import Reply from '../assets/reply.svg';

export function TweetReplyIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Reply} alt='reply' />;
}
